import { Filter } from "@/types/order-table";

interface IndexSignature {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export const filterCap = 500;

export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const checkSearchKeyMinCharCount = (type: Filter, searchString: string) => {

  if ((type === "orderName" && searchString.length >=2) || searchString.length >= 3) {
    return true;
  }
  return false;

};

export const objectToCSV = <T extends IndexSignature>(data: T[], options?: {excludes?: string[]}) => {
  if (data.length === 0) {
    throw new Error("Invalid data length | Data length should be greater than 0");
  }
  const csvRows = [];
  const headers = Object.keys(data[0])
  .filter(header => !options?.excludes?.includes(header))
  .filter(header => header != "documentType");

  csvRows.push(headers.join(','));

  for (const row of data) {
    const values = headers.map(header => {
      if (header == "orderName") {
        const val = String(row["documentType"]);
        return val.replaceAll(",", "").replaceAll("\n", " ").replaceAll("\r", " ");
      }
        const val = String(row[header]);
        return val.replaceAll(",", "").replaceAll("\n", " ").replaceAll("\r", " ");
    });

    csvRows.push(values.join(','));
}

return csvRows.join('\n');
};

/**
 * @description Helper function that will return a query string
 * @param key - the key to get the value for
 * @returns - the value of the key in the query string
 */
export const getQueryString = (key: string) =>
  new URLSearchParams(window.location.search).get(key);
